import {BehaviorSubject} from "rxjs";
import {hookFromSubject, promiseToSubject, ResponseSubjectState} from "./index";
import {CertificateApi, CertificateCreateDto, Configuration} from "../generated-api";
import { getCustomHeaders } from "./user";

const {REACT_APP_API_DOMAIN} = process.env;
const certificateApi = new CertificateApi(new Configuration({
    basePath: REACT_APP_API_DOMAIN,
    getHeaders: getCustomHeaders
}));

export const certificateCreateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCertificateCreate = hookFromSubject(certificateCreateSubject);
export const createCertificate = (templateId: string, body?: CertificateCreateDto) =>
    promiseToSubject(certificateApi.apiCertificateGroupTemplateIdPost({templateId}, body), certificateCreateSubject);

export const certificateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCertificate = hookFromSubject(certificateSubject);
export const getCertificate = (certificateId: string, suppressErrors?: boolean) =>
    promiseToSubject(certificateApi.apiCertificateCertificateIdGet({certificateId}), certificateSubject, {suppressErrors});

export const certificatesSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCertificates = hookFromSubject(certificatesSubject);
export const getCertificates = (skip: number, take: number, templateId: string, fullSearch?: string) =>
    promiseToSubject(certificateApi.apiCertificateGet({skip, take, templateId, fullSearch}), certificatesSubject);

export const certificatesChainSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCertificatesChain = hookFromSubject(certificatesChainSubject);
export const getCertificatesChain = (certificateId: string, suppressErrors?: boolean) =>
    promiseToSubject(certificateApi.apiCertificateCertificateIdChainGet({certificateId}), certificatesChainSubject, {suppressErrors});

export const downloadDocumentSubject = new BehaviorSubject(new ResponseSubjectState());
export const useDownloadDocument = hookFromSubject(downloadDocumentSubject);
export const downloadDocument = (certificateId: string, documentId: string) =>
    promiseToSubject(certificateApi.apiCertificateCertificateIdDocumentDocumentIdGet({
        certificateId,
        documentId
    }), downloadDocumentSubject);
export const downloadDocuments = (certificateId: string) =>
    promiseToSubject(certificateApi.apiCertificateCertificateIdDocumentGet({certificateId}), downloadDocumentSubject);

export const downloadWatermarkPreviewSubject = new BehaviorSubject(new ResponseSubjectState());
export const useDownloadWatermarkPreviewDocument = hookFromSubject(downloadWatermarkPreviewSubject);
export const downloadWatermarkPreviewDocument = (watermarkImgBase64: string, watermarkText: string) =>
    promiseToSubject(certificateApi.apiCertificateWatermarkPreviewPost({watermarkImgBase64, watermarkText}), downloadWatermarkPreviewSubject);

export const documentGuidDeleteSubject = new BehaviorSubject(new ResponseSubjectState());
export const useDocumentGuidDelete = hookFromSubject(documentGuidDeleteSubject);
export const deleteDocumentGuid = (fileId: string) =>
    promiseToSubject(certificateApi.apiCertificateFileFileIdDelete({fileId}), documentGuidDeleteSubject);


    export const certificateSftpCertificateIdPostSubject = new BehaviorSubject(new ResponseSubjectState());
    export const useiCertificateSftpCertificateIdPostCreate = hookFromSubject(certificateSftpCertificateIdPostSubject);
    export const sendToSftpPost = (certificateId: string, referenceValue: string) =>
        promiseToSubject(certificateApi.apiCertificateSftpCertificateIdRefReferenceValuePost({certificateId, referenceValue}), certificateSftpCertificateIdPostSubject);
    